import * as React from "react";
import { connect } from "react-redux";

import { ThunkDispatch } from "redux-thunk";
import { Form } from "semantic-ui-react";
import { createValidator } from "not-valid";

import { FormBaseComponent, SaveDispatchProps } from "@neworbit/simpleui-forms";
import { Input } from "@neworbit/simpleui-input";

import {
    AppState,
    CustomerSraDepartmentCreateModel,
    CustomerSraDepartmentDetailModel
} from "@teamprevent/common/customerSraDepartment/model";

import { Customer, CustomerState, selectors } from "../../customer";
import { createCustomerSraDepartment } from "../actions";
import { basePathSelector } from "../selectors";
import { SelectorState, customerSraDepartmentsSelector } from "../selectors";

import { CreateModal } from "./CreateModal";

import { push } from "redux-little-router";

export interface CreateProps {
    open: boolean;
    customer: Customer;
    customerSraDepartments: CustomerSraDepartmentDetailModel[];
}

export interface DispatchProps extends SaveDispatchProps<CustomerSraDepartmentCreateModel> {
    close: () => void;
}

export class CreateUnconnected extends FormBaseComponent<CustomerSraDepartmentCreateModel, CreateProps> {

    constructor(props: CreateProps & SaveDispatchProps<CustomerSraDepartmentCreateModel>) {
        super(props);
        this.state = {
            values: {
                id: "0",
                name: "",
            },
            valid: {}
        };

        this.notDuplicate = this.notDuplicate.bind(this);
    }

    private notDuplicate = createValidator<string>(
        value =>
            !this.props.customerSraDepartments ||
            !Array.isArray(this.props.customerSraDepartments) ||
            !this.props.customerSraDepartments.some((wg) => wg.name === value),
        "SRA Department with this name already exists"
    );

    public UNSAFE_componentWillReceiveProps(props: CreateProps & SaveDispatchProps<CustomerSraDepartmentCreateModel>) {
        this.setState(current => ({ values: { ...current.values, customerId: props.customer.id } }));
    }

    public render() {
        return (
            <Form onSubmit={this.handleSubmit}>
                <Input.Text
                    value={this.state.values.name}
                    label="Name"
                    required={true}
                    showErrors={this.state.showErrors}
                    onChange={this.onUpdateName}
                    validation={[this.notDuplicate]}
                />
                <Form.Field>
                    <label>Customer</label>
                    <span>{this.props.customer.name}</span>
                </Form.Field>
            </Form>
        );
    }

    public submit(): void {
        this.handleSubmit({ preventDefault: (): void => undefined } as any);
    }

    private onUpdateName = (value: string, valid: boolean) => this.updateProperty("name", value, valid);
}

function mapStateToProps(state: AppState & CustomerState & SelectorState) {
    return {
        customer: selectors.customerSelector(state),
        customerSraDepartments: customerSraDepartmentsSelector(state),
        open: state.router.pathname.endsWith("/create"),
        basePath: basePathSelector(state)
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch<AppState, undefined, any>) {
    return {
        dispatchSave: (customerId: string, customerSraDepartment: CustomerSraDepartmentCreateModel, basePath: string) =>
            dispatch(createCustomerSraDepartment(customerId, customerSraDepartment, basePath)),
        dispatchClose: (basePath: string) => dispatch(push(basePath, {}))
    };
}

function mergeProps(propsFromState: any, propsFromDispatch: any): CreateProps & DispatchProps {
    return {
        customer: propsFromState.customer,
        customerSraDepartments: propsFromState.customerSraDepartments,
        open: propsFromState.open,
        save: (customerSraDepartment: CustomerSraDepartmentCreateModel) =>
            propsFromDispatch.dispatchSave(propsFromState.customer.id, customerSraDepartment, propsFromState.basePath),
        close: () => propsFromDispatch.dispatchClose(propsFromState.basePath)
    };
}

export const Create = connect(mapStateToProps, mapDispatchToProps, mergeProps)(CreateModal);
